<template>
  <div>
    <template v-if="loading_dep === false">
      <div class="row">
        <div class="col s12 buttons-wrapper">
          <a v-if="show_form_dep === false" @click="addNew" class="waves-effect waves-light btn">Adicionar dependente</a>
          <a v-else @click="addNew" class="waves-effect waves-light btn red right">Cancelar</a>
        </div>
        <!--FORM DEP -->
        <div v-if="show_form_dep === true" class="form-dependentes-wrapper">
          <div class="input-field col s12 m6">
            <input v-model="new_dep.nome_dep" id="nome_dep" type="text" v-bind:class="{'invalid': error_fields['nome_dep']}">
            <label for="nome_dep">Nome</label>
            <span v-if="error_fields['nome_dep']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m6 cpf-wrapper">
            <input v-model="new_dep.cpf" v-mask="['###.###.###-##']" id="cpf_dependente" type="text">
            <label for="cpf_dependente">CPF</label>
          </div>
          <div class="input-field col s12 m3">
            <input v-model="new_dep.nascimento_dep" v-mask="['##/##/####']" placeholder="01/01/2000" type="text" id="nascimento_dep" v-bind:class="{'invalid': error_fields['nascimento_dep']}">
            <label for="nascimento_dep">Data de nascimento</label>
            <span v-if="error_fields['nascimento_dep']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m3">
            <select v-model="new_dep.sexo_dep" ref="sexo_dep" id="sexo_dep" v-bind:class="{'invalid': error_fields['sexo_dep']}">
              <option value="" selected>Selecione</option>
              <option value="m6rj36">Masculino</option>
              <option value="f6rj36">Feminino</option>
              <option value="ud5xhh">Outro</option>
            </select>
            <label for="sexo_dep">Sexo</label>
            <span v-if="error_fields['sexo_dep']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m6">
              <input v-model="new_dep.pf_rg" type="text" v-bind:class="{'invalid': error_fields['pf_rg']}" id="pf_rg" ref="pf_rg">
              <label for="pf_rg">Número do RG</label>
              <span v-if="error_fields['pf_rg']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m6">
              <input v-model="new_dep.pf_rg_emissao" v-mask="['##/##/####']" id="pf_rg_emissao" ref="pf_rg_emissao" type="text" v-bind:class="{'invalid': error_fields['pf_rg_emissao']}">
              <label for="pf_rg_emissao">Data de Emissão do RG</label>
              <span v-if="error_fields['pf_rg_emissao']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m6">
              <select v-model="new_dep.pf_rg_ent_classe_meta" v-bind:class="{'invalid': error_fields['pf_rg_ent_classe_meta']}" id="pf_rg_ent_classe_meta" ref="pf_rg_ent_classe_meta">
              <option v-bind:value="null" selected>Selecione</option>
              <option v-for="(orgao, i) in meta.rg_orgao_emissor" v-bind:key="i" v-bind:value="i">{{ orgao }}</option>
              </select>
              <label for="pf_rg_ent_classe_meta">Órgão Emissor do RG</label>
              <span v-if="error_fields['pf_rg_ent_classe_meta']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m6">
              <select v-model="new_dep.pf_rg_uf" v-bind:class="{'invalid': error_fields['pf_rg_uf']}" id="pf_rg_uf" ref="pf_rg_uf">
              <option v-bind:value="null" selected>Selecione</option>
              <option v-for="(uf, i) in meta.uf" v-bind:key="i" v-bind:value="i">{{ uf }}</option>
              </select>
              <label for="pf_rg_uf">UF do RG</label>
              <span v-if="error_fields['pf_rg_uf']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m3">
            <select v-model="new_dep.parentesco" @change="verificaFilhoNascido" ref="parentesco" id="parentesco" v-bind:class="{'invalid': error_fields['parentesco']}">
              <option value="" selected>Selecione</option>
              <option value="ytdld6">Filho</option>
              <option value="f4p7xc">Enteado</option>
              <option value="w8tnca">Conjuge</option>
              <option value="tnarzl">Companheiro</option>
              <option value="orad47">Pais</option>
              <option value="all2rq">Netos</option>
              <option value="bqcsnt">Irmãos</option>
              <option value="yfu1yn">Avós</option>
            </select>
            <label for="parentesco">Grau de parentesco</label>
            <span v-if="error_fields['parentesco']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m3">
            <select v-model="new_dep.pne" id="dep_deficiencia">
              <option v-bind:value="null" selected>Nenhuma</option>
              <option v-for="(pne, i) in meta.pne" v-bind:key="i" v-bind:value="i">{{ pne }}</option>
            </select>
            <label for="dep_deficiencia">Deficiência</label>
          </div>
          <div class="input-field col s12 m3">
            <select v-model="new_dep.motivo_inicio_dep" id="motivo_inicio_dep" type="text" v-bind:class="{'invalid': error_fields['motivo_inicio_dep']}">
              <option v-bind:value="null" selected>Selecione</option>
              <option v-for="(m_dep, i) in motivos_inicio_dep" v-bind:key="i" v-bind:value="i">{{ m_dep }}</option>
            </select>
            <label for="motivo_dep">Motivo do início da dependência</label>
            <span v-if="error_fields['motivo_inicio_dep']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m3">
            <input v-model="new_dep.inicio_dep" v-mask="['##/##/####']" placeholder="01/01/2000" type="text" id="data_inicio_dep" v-bind:class="{'invalid': error_fields['inicio_dep']}">
            <label for="data_inicio_dep">início da dependência</label>
            <span v-if="error_fields['inicio_dep']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
          </div>
          <div class="input-field col s12 m3">
            <input v-model="new_dep.fim_dep" v-mask="['##/##/####']" type="text" id="data_fim_dep">
            <label for="data_fim_dep">fim da dependência</label>
          </div>
          <div class="input-field col s12 m3">
            <select v-model="new_dep.motivo_fim_dep" id="motivo_dep" type="text">
              <option v-bind:value="null" selected>Selecione</option>
              <option v-for="(m_dep, i) in motivos_fim_dep" v-bind:key="i" v-bind:value="i">{{ m_dep }}</option>
            </select>
            <label for="motivo_dep">Motivo do fim da dependência</label>
          </div>
          <div class="col s12 m12">
            <a @click="prepareSubmitDependente" v-bind:disabled="verificaForm === false" class="waves-effect waves-light btn right">Salvar</a>
          </div>
        </div>
        <!--FORM DEP FIM -->

        <template v-else>
          <template v-for="(dep, i) in dependentes">
            <div class="col s12 m4" v-bind:key="i">
              <div class="card familia">
                <div class="card-content">
                  <div class="col s12 data-dep-wrapper">
                    <!-- <i class="material-icons no-photo">person</i> -->
                    <p>
                      {{ dep['nome'] }}
                      <br />
                      {{ (dep['cpf'] ? dep['cpf'] : '(SEM CPF)') }} 
                      <br >
                      <span class="parentesco">Nascimento: {{ dep['nascimento'] }}</span>
                      <span class="parentesco">
                        Parentesco: {{ meta.rel_familiar_simples[dep['parentesco']] }}
                      </span>
                    </p>
                  </div>
                </div>
                <div class="card-action">
                    <div class="col s12 censo">
                      <a @click="removeDependente(dep['pf_id'], dep['parentesco'])">
                        <i class="material-icons right red-text">delete</i>
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </template>

        </template>
      </div>
      <div class="step-actions">
        <button class="waves-effect waves-dark btn-flat previous-step">Anterior</button>
        <button v-bind:disabled="step_completed === false" type="button" @click="submitStep" class="waves-effect waves-dark btn">Próximo</button>
      </div>
    </template>
    <template v-else>
      <loading />
    </template>
  </div>
</template>
<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import SocialService from '@/services/social-service.js'
import { validaCPF, formataCPF, verificaData, formataData, converteData } from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

  export default {
    name: 'Dependentes',
    components: {
      loading: Loading
    },
    props: {
      stepper: Object,
      active_step: Number,
      dependentes_data: Object,
    },
    data (){
      return {
        meta: this.$store.state.meta.data,
        pf_id: this.$store.state.user.pfId,
        loading_dep: false,
        changed: false,
        step_completed: true,
        show_form_dep: false,
        dependentes: [],
        new_dep: {
          nome_dep: null,
          cpf: null,
          nascimento_dep: null,
          sexo_dep: null,
          obito: null,
          parentesco: null,
          motivo_inicio_dep: null,
          inicio_dep: null,
          fim_dep: null,
          motivo_fim_dep: null,
          pne: null,
          pf_rg: null,
          pf_rg_emissao: null,
          pf_rg_uf: null,
          pf_rg_ent_classe_meta: null,
        },
        motivos_inicio_dep: {
          '1': "Nascimento",
          '2': "Invalidez",
          '3': "Casamento",
          '4': "União Estável ",
          '5': "Adoção",
          '6': "Decisão Judicial ",
          '7': "Dependência Econômica ",
          '8': "Filho Póstumo",
          '9': "Tutela",
          '10': "Pedido do Servidor ",
          '11': "Outros",
        },
        motivos_fim_dep: {
          '51': "Maioridade",
          '52': "Óbito",
          '53': "Separação Judicial",
          '54': "Divórcio",
          '62': "Separado de fato 6",
          '55': "Emancipaçã",
          '56': "Decisão Judicial",
          '57': "Cessação de Invalidez",
          '58': "Independência Econômica",
          '59': "Revogação da Tutela",
          '60': "Pedido do Servidor",
          '61': "Outros"
        },
        error_fields: {},
        error: null
    }
  },
  computed: {
    verificaForm: function() {
      return (
        ['nome_dep', 'nascimento_dep', 'inicio_dep', 'motivo_inicio_dep', 'sexo_dep', 'parentesco'].filter((k) => this.new_dep[k] && this.new_dep[k] != '').length >= 6
        &&
        verificaData(this.new_dep.nascimento_dep) === true && verificaData(this.new_dep.inicio_dep) === true
      )
    },
    dependentes_registered: function () {
      return this.dependentes
    }
  },
  methods: {
    verificaFilhoNascido(){
      if(this.new_dep.nascimento_dep.length === 10){
        if(this.new_dep.parentesco === 'ytdld6'){
          this.new_dep.inicio_dep = this.new_dep.nascimento_dep
        }
      }
    },
    async submitDependente(dependente){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/inserir/`, {
        ...dependente,
        ...{
          'device': await socialService.getDeviceInfo()
        }
      })
      .then(async (response) => {
        this.submitExtrasDependente(response.data.data.SocialAPI.pf_id)
        this.submitRelDependente(response.data.data.SocialAPI.pf_id)
        this.submitRGDependente(response.data.data.SocialAPI.pf_id)
      })
      .catch((error) => {
        if(error.response.status === 400){
          //Usuário tentou cadastrar CPF já existente, ignore e reenvie a requisição com CPF null
          this.submitDependente({
            ...dependente,
            ...{
              'cpf': null,
            }
          })
        } else {
          this.loading_dep = false
          this.$root.$emit('stopLoadingHeader')
          this.initFields()
          M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        }
      })
    },
    async submitRelDependente(pf_id){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/familia/`, {
        "pf_id": this.pf_id,
        "ref_id": pf_id,
        "clas": this.new_dep.parentesco,
        "device": await socialService.getDeviceInfo()
      })
      .then(() => {})
      .catch((error) => {})
      .finally(() => {
        this.dependentes.push({
          pf_id: pf_id,
          cpf: (validaCPF(this.new_dep.cpf) === true ? this.new_dep.cpf.replace(/[^0-9]/g, '') : null),
          nome: this.new_dep.nome_dep,
          nascimento: this.new_dep.nascimento_dep,
          parentesco: this.new_dep.parentesco
        })
        this.$root.$emit('stopLoadingHeader')
        this.show_form_dep = false
        this.loading_dep = false
      })
    },
    submitExtrasDependente(pf_id){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/dep-extras/`, {
        "parent_id": this.pf_id,
        "pf_id": pf_id,
        "rel": this.new_dep.parentesco,
        "data_inicio_dep": formataData(this.new_dep.inicio_dep),
        "motivo_inicio_dep": this.new_dep.motivo_inicio_dep,
        "data_fim_dep": (verificaData(this.new_dep.fim_dep) ? formataData(this.new_dep.fim_dep) : null),
        "motivo_fim_dep": this.new_dep.motivo_fim_dep,
        "dep_irrf": "N",
        "dep_previdenciario": "S",
        "observacao": null
      })
      .then((response) => {
      })
      .catch((errror) => {
      })
    },
    async submitRGDependente(pf_id){
      if(this.new_dep.pf_rg && verificaData(this.new_dep.pf_rg_emissao) === true && this.new_dep.pf_rg_ent_classe_meta && this.new_dep.pf_rg_uf){
        axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/identidade/`, {
          "pf_rg": this.new_dep.pf_rg,
          "pf_rg_emissao": formataData(this.new_dep.pf_rg_emissao),
          "pf_rg_uf": this.new_dep.pf_rg_uf,
          "pf_rg_ent_classe_meta": this.new_dep.pf_rg_ent_classe_meta,
          "pf_id": pf_id,
          "device": await socialService.getDeviceInfo()
        })
        .then((response) => {
        })
        .catch((error) => {
        })
      }
    },
    prepareSubmitDependente(){
      this.$root.$emit('loadingHeader')
      this.loading_dep = true
      
      this.submitDependente({
        nome: this.new_dep.nome_dep,
        cpf: (validaCPF(this.new_dep.cpf) === true ? this.new_dep.cpf.replace(/[^0-9]/g, '') : null),
        sexo: this.new_dep.sexo_dep,
        nascimento: formataData(this.new_dep.nascimento_dep),
      })
    },
    async removeDependente(pf_id_dep, clas){
      this.$root.$emit('loadingHeader')
      this.loading_dep = true
      axios({
        method: "DELETE",
        url: `${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/familia/${this.pf_id}/${pf_id_dep}/`, 
        data: {
          "clas": clas,
          "device": await socialService.getDeviceInfo()
        }
      })
      .then(() =>{
        this.dependentes.forEach((dep, i) => {
          if(dep['pf_id'] === pf_id_dep){
            this.dependentes.splice(i, 1)
          }
        })
      })
      .catch((error) => {

      })
      .finally(() => {
        this.$root.$emit('stopLoadingHeader')
        this.loading_dep = false
      })
    },
    addNew(){
      this.show_form_dep = !this.show_form_dep
      this.new_dep = {
        nome_dep: null,
        cpf: null,
        nascimento_dep: null,
        sexo_dep: null,
        parentesco: null,
        motivo_inicio_dep: null,
        inicio_dep: null,
        fim_dep: null,
        motivo_fim_dep: null,
        pne: null,
        pf_rg: null,
        pf_rg_emissao: null,
        pf_rg_uf: null,
        pf_rg_ent_classe_meta: null,

        }
      this.initFields()
    },
    verificaStatusPasso(){
      let keys = ['nome_dep']
      let selectKeys = ['sexo_dep', 'parentesco', 'motivo_inicio_dep']
      let dateKeys = ['nascimento_dep', 'inicio_dep']

      let status = true //Até que se prove o contrário
      keys.forEach((key) => {
        if(this.new_dep[key] == null || this.new_dep[key] == ''){
          status = false
          this.$set(this.error_fields, key, true)
        } else {
          this.$set(this.error_fields, key, false)
        }
      })

      dateKeys.forEach((dKey) => {
        if(this.new_dep[dKey] == null || verificaData(this.new_dep[dKey]) === false){
          status = false
          this.$set(this.error_fields, dKey, true)
        } else {
          this.$set(this.error_fields, dKey, false)
        }
      })

      selectKeys.forEach((sKey) => {
        try{
          if(this.new_dep[sKey] == null || this.new_dep[sKey] == ''){
            status = false
            M.FormSelect.getInstance(document.getElementById(sKey)).wrapper.classList.add('invalid')
            this.$set(this.error_fields, sKey, false)
          } else {
            M.FormSelect.getInstance(document.getElementById(sKey)).wrapper.classList.remove('invalid')
            this.$set(this.error_fields, sKey, true)
          }
        } catch(e) {
          status = false
        }
      })
      return status
    },
    initFields() {
      setTimeout(() => {
        M.FormSelect.init(document.querySelectorAll('select'))
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
        M.updateTextFields()
      }, 200)
    },
    submitStep() {
      this.$emit('moveNextStep', {step: 3, completed: this.step_completed})
    },
    initStep(){
      setTimeout(() => {
        M.updateTextFields()
        M.FormSelect.init(document.querySelectorAll('select'))
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
        this.changed = false
      }, 200)
    }
  },
  watch: {
    new_dep: {
      handler: function(updated_perfil, old_perfil){
        this.changed = true
        setTimeout(() => {
          this.verificaStatusPasso()
        })
      },
      deep: true
    }
  },
  mounted(){
    for(let rel in this.dependentes_data){
      this.dependentes_data[rel].forEach((dep) => {
        this.dependentes.push({
          pf_id: dep['id'],
          cpf: (dep['cpf'] !== null ? formataCPF(dep['cpf']) : null),
          nome: dep['nome'],
          nascimento: converteData(dep['nascimento']),
          parentesco: rel
        })
      })
    }
    this.initStep()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/steps/Dependentes.vue